<div class="outline-comments__box__comment" [class.active]="active">
    <div class="outline-comments__box__comment__header">
        <app-status-label
                [cssClasses]="'status-label__blue'"
                [statusLabelText]="stripHTMLTags(comment.informationUnitTitle)">
        </app-status-label>
        <app-dropdown-button *ngIf="showCommentActions"
                             [sideMenuOpen]="sideMenuOpen"
                             [disabled]="disabled"
                             [triggerData]="triggerData"
                             [menuItems]="menuItems"
                             (buttonEvent)="buttonActions($event)">
        </app-dropdown-button>
        <div *ngIf="markComment" class="status-icon">
            <mat-icon class="material-icons-round success">check_circle</mat-icon>
        </div>
    </div>
    <p class="outline-comments__box__comment__text" [class.elipsis]="!showEntireComment" [innerHTML]="comment.content"></p>
</div>
